// extracted by mini-css-extract-plugin
export default {"wrapper":"Step9_wrapper__PGqMa","help":"Step9_help__oZ+SM","noBankIdLink":"Step9_noBankIdLink__N1qaq","popup":"Step9_popup__5D9yY","loading":"Step9_loading__FQcJt"};